import { getCameraProvider, isCameraDebugEnabled } from "./provider";
import { useNativeCameraSnapshot } from "./useNativeCamera";

/** Test-only readout of the active camera provider and the wrapper's last camera event. */
export function CameraDebugBadge() {
	const snapshot = useNativeCameraSnapshot();
	if (!isCameraDebugEnabled()) return null;

	const photo = snapshot.geometry ? `${snapshot.geometry.photo.width}x${snapshot.geometry.photo.height}` : "-";
	const torch = snapshot.state ? String(snapshot.state.torch) : "-";
	const zoom = snapshot.state ? snapshot.state.zoom.toFixed(1) : "-";
	const focus = snapshot.focus?.phase ?? "-";
	const modes = snapshot.state ? `${snapshot.state.focusMode ?? "-"}/${snapshot.state.exposureMode ?? "-"}` : "-";
	const thermal = snapshot.thermal ?? "-";
	const model = snapshot.deviceModel ?? "-";
	const error = snapshot.error ? ` · error ${snapshot.error.code}: ${snapshot.error.message}` : "";

	return (
		<div
			data-camera-debug=""
			className="pointer-events-none fixed bottom-2 left-2 z-[70] max-w-[90vw] rounded bg-black/70 px-2 py-1 font-mono text-[10px] leading-tight text-lime-300"
		>
			camera {getCameraProvider()} · {snapshot.status} · facing {snapshot.facing ?? "-"} · photo {photo} · torch {torch}{" "}
			· zoom {zoom} · focus {focus} · modes {modes} · thermal {thermal} · dev {model} · last {snapshot.lastEvent ?? "-"}
			{error}
		</div>
	);
}
